// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"3b3926b8","1219":"2a0f5e9d","2404":"2aff2bf9","3201":"ef6aa4c0","4515":"2aff2bf9"}[chunkId] + ".chunk.css";
};